// ***** zaklad - opravdu jen zakladni featury
/*! jQuery Easing v1.3 - http://gsgd.co.uk/sandbox/jquery/easing/ */
jQuery.easing['jswing']=jQuery.easing['swing'];jQuery.extend(jQuery.easing,{def:'easeOutQuad',swing:function(x,t,b,c,d){return jQuery.easing[jQuery.easing.def](x,t,b,c,d);},easeInQuad:function(x,t,b,c,d){return c*(t/=d)*t+b;},easeOutQuad:function(x,t,b,c,d){return-c*(t/=d)*(t-2)+b;},easeInOutQuad:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t+b;return-c/2*((--t)*(t-2)-1)+b;},easeInCubic:function(x,t,b,c,d){return c*(t/=d)*t*t+b;},easeOutCubic:function(x,t,b,c,d){return c*((t=t/d-1)*t*t+1)+b;},easeInOutCubic:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t*t+b;return c/2*((t-=2)*t*t+2)+b;},easeInQuart:function(x,t,b,c,d){return c*(t/=d)*t*t*t+b;},easeOutQuart:function(x,t,b,c,d){return-c*((t=t/d-1)*t*t*t-1)+b;},easeInOutQuart:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t*t*t+b;return-c/2*((t-=2)*t*t*t-2)+b;},easeInQuint:function(x,t,b,c,d){return c*(t/=d)*t*t*t*t+b;},easeOutQuint:function(x,t,b,c,d){return c*((t=t/d-1)*t*t*t*t+1)+b;},easeInOutQuint:function(x,t,b,c,d){if((t/=d/2)<1)return c/2*t*t*t*t*t+b;return c/2*((t-=2)*t*t*t*t+2)+b;},easeInSine:function(x,t,b,c,d){return-c*Math.cos(t/d*(Math.PI/2))+c+b;},easeOutSine:function(x,t,b,c,d){return c*Math.sin(t/d*(Math.PI/2))+b;},easeInOutSine:function(x,t,b,c,d){return-c/2*(Math.cos(Math.PI*t/d)-1)+b;},easeInExpo:function(x,t,b,c,d){return(t==0)?b:c*Math.pow(2,10*(t/d-1))+b;},easeOutExpo:function(x,t,b,c,d){return(t==d)?b+c:c*(-Math.pow(2,-10*t/d)+1)+b;},easeInOutExpo:function(x,t,b,c,d){if(t==0)return b;if(t==d)return b+c;if((t/=d/2)<1)return c/2*Math.pow(2,10*(t-1))+b;return c/2*(-Math.pow(2,-10*--t)+2)+b;},easeInCirc:function(x,t,b,c,d){return-c*(Math.sqrt(1-(t/=d)*t)-1)+b;},easeOutCirc:function(x,t,b,c,d){return c*Math.sqrt(1-(t=t/d-1)*t)+b;},easeInOutCirc:function(x,t,b,c,d){if((t/=d/2)<1)return-c/2*(Math.sqrt(1-t*t)-1)+b;return c/2*(Math.sqrt(1-(t-=2)*t)+1)+b;},easeInElastic:function(x,t,b,c,d){var s=1.70158;var p=0;var a=c;if(t==0)return b;if((t/=d)==1)return b+c;if(!p)p=d*.3;if(a<Math.abs(c)){a=c;var s=p/4;}else var s=p/(2*Math.PI)*Math.asin(c/a);return-(a*Math.pow(2,10*(t-=1))*Math.sin((t*d-s)*(2*Math.PI)/p))+b;},easeOutElastic:function(x,t,b,c,d){var s=1.70158;var p=0;var a=c;if(t==0)return b;if((t/=d)==1)return b+c;if(!p)p=d*.3;if(a<Math.abs(c)){a=c;var s=p/4;}else var s=p/(2*Math.PI)*Math.asin(c/a);return a*Math.pow(2,-10*t)*Math.sin((t*d-s)*(2*Math.PI)/p)+c+b;},easeInOutElastic:function(x,t,b,c,d){var s=1.70158;var p=0;var a=c;if(t==0)return b;if((t/=d/2)==2)return b+c;if(!p)p=d*(.3*1.5);if(a<Math.abs(c)){a=c;var s=p/4;}else var s=p/(2*Math.PI)*Math.asin(c/a);if(t<1)return-.5*(a*Math.pow(2,10*(t-=1))*Math.sin((t*d-s)*(2*Math.PI)/p))+b;return a*Math.pow(2,-10*(t-=1))*Math.sin((t*d-s)*(2*Math.PI)/p)*.5+c+b;},easeInBack:function(x,t,b,c,d,s){if(s==undefined)s=1.70158;return c*(t/=d)*t*((s+1)*t-s)+b;},easeOutBack:function(x,t,b,c,d,s){if(s==undefined)s=1.70158;return c*((t=t/d-1)*t*((s+1)*t+s)+1)+b;},easeInOutBack:function(x,t,b,c,d,s){if(s==undefined)s=1.70158;if((t/=d/2)<1)return c/2*(t*t*(((s*=(1.525))+1)*t-s))+b;return c/2*((t-=2)*t*(((s*=(1.525))+1)*t+s)+2)+b;},easeInBounce:function(x,t,b,c,d){return c-jQuery.easing.easeOutBounce(x,d-t,0,c,d)+b;},easeOutBounce:function(x,t,b,c,d){if((t/=d)<(1/2.75)){return c*(7.5625*t*t)+b;}else if(t<(2/2.75)){return c*(7.5625*(t-=(1.5/2.75))*t+.75)+b;}else if(t<(2.5/2.75)){return c*(7.5625*(t-=(2.25/2.75))*t+.9375)+b;}else{return c*(7.5625*(t-=(2.625/2.75))*t+.984375)+b;}},easeInOutBounce:function(x,t,b,c,d){if(t<d/2)return jQuery.easing.easeInBounce(x,t*2,0,c,d)*.5+b;return jQuery.easing.easeOutBounce(x,t*2-d,0,c,d)*.5+c*.5+b;}});

// retina detection
(function() {
	document.cookie = "IMG_HI_RES=" + (window.devicePixelRatio > 1.5 ? 1 : 0)
})();

/* Get transition duration */
/* https://gist.github.com/snorpey/5323028 baushop*/
function getTransitionDuration(e,t){var n=$(e);var r="moz webkit ms o khtml".split(" ");var i=0;for(var s=0;s<r.length;s++){var o=n.css("-"+r[s]+"-transition-duration");if(o){o=o.indexOf("ms")>-1?parseFloat(o):parseFloat(o)*1e3;if(t){var u=n.css("-"+r[s]+"-transition-delay");o+=u.indexOf("ms")>-1?parseFloat(u):parseFloat(u)*1e3}i=o;break}}return i};

/*TouchSwipe - jQuery Plugin, version 1.6.0*/
(function(a){if(typeof define==="function"&&define.amd&&define.amd.jQuery){define(["jquery"],a)}else{a(jQuery)}}(function(f){var y="1.6.12",p="left",o="right",e="up",x="down",c="in",A="out",m="none",s="auto",l="swipe",t="pinch",B="tap",j="doubletap",b="longtap",z="hold",E="horizontal",u="vertical",i="all",r=10,g="start",k="move",h="end",q="cancel",a="ontouchstart" in window,v=window.navigator.msPointerEnabled&&!window.navigator.pointerEnabled,d=window.navigator.pointerEnabled||window.navigator.msPointerEnabled,C="TouchSwipe";var n={fingers:1,threshold:75,cancelThreshold:null,pinchThreshold:20,maxTimeThreshold:null,fingerReleaseThreshold:250,longTapThreshold:500,doubleTapThreshold:200,swipe:null,swipeLeft:null,swipeRight:null,swipeUp:null,swipeDown:null,swipeStatus:null,pinchIn:null,pinchOut:null,pinchStatus:null,click:null,tap:null,doubleTap:null,longTap:null,hold:null,triggerOnTouchEnd:true,triggerOnTouchLeave:false,allowPageScroll:"auto",fallbackToMouseEvents:true,excludedElements:"label, button, input, select, textarea, a, .noSwipe",preventDefaultEvents:true};f.fn.swipe=function(H){var G=f(this),F=G.data(C);if(F&&typeof H==="string"){if(F[H]){return F[H].apply(this,Array.prototype.slice.call(arguments,1))}else{f.error("Method "+H+" does not exist on jQuery.swipe")}}else{if(F&&typeof H==="object"){F.option.apply(this,arguments)}else{if(!F&&(typeof H==="object"||!H)){return w.apply(this,arguments)}}}return G};f.fn.swipe.version=y;f.fn.swipe.defaults=n;f.fn.swipe.phases={PHASE_START:g,PHASE_MOVE:k,PHASE_END:h,PHASE_CANCEL:q};f.fn.swipe.directions={LEFT:p,RIGHT:o,UP:e,DOWN:x,IN:c,OUT:A};f.fn.swipe.pageScroll={NONE:m,HORIZONTAL:E,VERTICAL:u,AUTO:s};f.fn.swipe.fingers={ONE:1,TWO:2,THREE:3,FOUR:4,FIVE:5,ALL:i};function w(F){if(F&&(F.allowPageScroll===undefined&&(F.swipe!==undefined||F.swipeStatus!==undefined))){F.allowPageScroll=m}if(F.click!==undefined&&F.tap===undefined){F.tap=F.click}if(!F){F={}}F=f.extend({},f.fn.swipe.defaults,F);return this.each(function(){var H=f(this);var G=H.data(C);if(!G){G=new D(this,F);H.data(C,G)}})}function D(a4,au){var au=f.extend({},au);var az=(a||d||!au.fallbackToMouseEvents),K=az?(d?(v?"MSPointerDown":"pointerdown"):"touchstart"):"mousedown",ax=az?(d?(v?"MSPointerMove":"pointermove"):"touchmove"):"mousemove",V=az?(d?(v?"MSPointerUp":"pointerup"):"touchend"):"mouseup",T=az?null:"mouseleave",aD=(d?(v?"MSPointerCancel":"pointercancel"):"touchcancel");var ag=0,aP=null,ac=0,a1=0,aZ=0,H=1,ap=0,aJ=0,N=null;var aR=f(a4);var aa="start";var X=0;var aQ={};var U=0,a2=0,a5=0,ay=0,O=0;var aW=null,af=null;try{aR.bind(K,aN);aR.bind(aD,a9)}catch(aj){f.error("events not supported "+K+","+aD+" on jQuery.swipe")}this.enable=function(){aR.bind(K,aN);aR.bind(aD,a9);return aR};this.disable=function(){aK();return aR};this.destroy=function(){aK();aR.data(C,null);aR=null};this.option=function(bc,bb){if(typeof bc==="object"){au=f.extend(au,bc)}else{if(au[bc]!==undefined){if(bb===undefined){return au[bc]}else{au[bc]=bb}}else{if(!bc){return au}else{f.error("Option "+bc+" does not exist on jQuery.swipe.options")}}}return null};function aN(bd){if(aB()){return}if(f(bd.target).closest(au.excludedElements,aR).length>0){return}var be=bd.originalEvent?bd.originalEvent:bd;var bc,bf=be.touches,bb=bf?bf[0]:be;aa=g;if(bf){X=bf.length}else{if(au.preventDefaultEvents!==false){bd.preventDefault()}}ag=0;aP=null;aJ=null;ac=0;a1=0;aZ=0;H=1;ap=0;N=ab();S();ai(0,bb);if(!bf||(X===au.fingers||au.fingers===i)||aX()){U=ar();if(X==2){ai(1,bf[1]);a1=aZ=at(aQ[0].start,aQ[1].start)}if(au.swipeStatus||au.pinchStatus){bc=P(be,aa)}}else{bc=false}if(bc===false){aa=q;P(be,aa);return bc}else{if(au.hold){af=setTimeout(f.proxy(function(){aR.trigger("hold",[be.target]);if(au.hold){bc=au.hold.call(aR,be,be.target)}},this),au.longTapThreshold)}an(true)}return null}function a3(be){var bh=be.originalEvent?be.originalEvent:be;if(aa===h||aa===q||al()){return}var bd,bi=bh.touches,bc=bi?bi[0]:bh;var bf=aH(bc);a2=ar();if(bi){X=bi.length}if(au.hold){clearTimeout(af)}aa=k;if(X==2){if(a1==0){ai(1,bi[1]);a1=aZ=at(aQ[0].start,aQ[1].start)}else{aH(bi[1]);aZ=at(aQ[0].end,aQ[1].end);aJ=aq(aQ[0].end,aQ[1].end)}H=a7(a1,aZ);ap=Math.abs(a1-aZ)}if((X===au.fingers||au.fingers===i)||!bi||aX()){aP=aL(bf.start,bf.end);ak(be,aP);ag=aS(bf.start,bf.end);ac=aM();aI(aP,ag);if(au.swipeStatus||au.pinchStatus){bd=P(bh,aa)}if(!au.triggerOnTouchEnd||au.triggerOnTouchLeave){var bb=true;if(au.triggerOnTouchLeave){var bg=aY(this);bb=F(bf.end,bg)}if(!au.triggerOnTouchEnd&&bb){aa=aC(k)}else{if(au.triggerOnTouchLeave&&!bb){aa=aC(h)}}if(aa==q||aa==h){P(bh,aa)}}}else{aa=q;P(bh,aa)}if(bd===false){aa=q;P(bh,aa)}}function M(bb){var bc=bb.originalEvent?bb.originalEvent:bb,bd=bc.touches;if(bd){if(bd.length&&!al()){G();return true}else{if(bd.length&&al()){return true}}}if(al()){X=ay}a2=ar();ac=aM();if(ba()||!am()){aa=q;P(bc,aa)}else{if(au.triggerOnTouchEnd||(au.triggerOnTouchEnd==false&&aa===k)){if(au.preventDefaultEvents!==false){bb.preventDefault()}aa=h;P(bc,aa)}else{if(!au.triggerOnTouchEnd&&a6()){aa=h;aF(bc,aa,B)}else{if(aa===k){aa=q;P(bc,aa)}}}}an(false);return null}function a9(){X=0;a2=0;U=0;a1=0;aZ=0;H=1;S();an(false)}function L(bb){var bc=bb.originalEvent?bb.originalEvent:bb;if(au.triggerOnTouchLeave){aa=aC(h);P(bc,aa)}}function aK(){aR.unbind(K,aN);aR.unbind(aD,a9);aR.unbind(ax,a3);aR.unbind(V,M);if(T){aR.unbind(T,L)}an(false)}function aC(bf){var be=bf;var bd=aA();var bc=am();var bb=ba();if(!bd||bb){be=q}else{if(bc&&bf==k&&(!au.triggerOnTouchEnd||au.triggerOnTouchLeave)){be=h}else{if(!bc&&bf==h&&au.triggerOnTouchLeave){be=q}}}return be}function P(bd,bb){var bc,be=bd.touches;if((J()&&W())||(Q()&&aX())){if(J()&&W()){bc=aF(bd,bb,l)}if((Q()&&aX())&&bc!==false){bc=aF(bd,bb,t)}}else{if(aG()&&bc!==false){bc=aF(bd,bb,j)}else{if(ao()&&bc!==false){bc=aF(bd,bb,b)}else{if(ah()&&bc!==false){bc=aF(bd,bb,B)}}}}if(bb===q){if(W()){bc=aF(bd,bb,l)}if(aX()){bc=aF(bd,bb,t)}a9(bd)}if(bb===h){if(be){if(!be.length){a9(bd)}}else{a9(bd)}}return bc}function aF(be,bb,bd){var bc;if(bd==l){aR.trigger("swipeStatus",[bb,aP||null,ag||0,ac||0,X,aQ]);if(au.swipeStatus){bc=au.swipeStatus.call(aR,be,bb,aP||null,ag||0,ac||0,X,aQ);if(bc===false){return false}}if(bb==h&&aV()){aR.trigger("swipe",[aP,ag,ac,X,aQ]);if(au.swipe){bc=au.swipe.call(aR,be,aP,ag,ac,X,aQ);if(bc===false){return false}}switch(aP){case p:aR.trigger("swipeLeft",[aP,ag,ac,X,aQ]);if(au.swipeLeft){bc=au.swipeLeft.call(aR,be,aP,ag,ac,X,aQ)}break;case o:aR.trigger("swipeRight",[aP,ag,ac,X,aQ]);if(au.swipeRight){bc=au.swipeRight.call(aR,be,aP,ag,ac,X,aQ)}break;case e:aR.trigger("swipeUp",[aP,ag,ac,X,aQ]);if(au.swipeUp){bc=au.swipeUp.call(aR,be,aP,ag,ac,X,aQ)}break;case x:aR.trigger("swipeDown",[aP,ag,ac,X,aQ]);if(au.swipeDown){bc=au.swipeDown.call(aR,be,aP,ag,ac,X,aQ)}break}}}if(bd==t){aR.trigger("pinchStatus",[bb,aJ||null,ap||0,ac||0,X,H,aQ]);if(au.pinchStatus){bc=au.pinchStatus.call(aR,be,bb,aJ||null,ap||0,ac||0,X,H,aQ);if(bc===false){return false}}if(bb==h&&a8()){switch(aJ){case c:aR.trigger("pinchIn",[aJ||null,ap||0,ac||0,X,H,aQ]);if(au.pinchIn){bc=au.pinchIn.call(aR,be,aJ||null,ap||0,ac||0,X,H,aQ)}break;case A:aR.trigger("pinchOut",[aJ||null,ap||0,ac||0,X,H,aQ]);if(au.pinchOut){bc=au.pinchOut.call(aR,be,aJ||null,ap||0,ac||0,X,H,aQ)}break}}}if(bd==B){if(bb===q||bb===h){clearTimeout(aW);clearTimeout(af);if(Z()&&!I()){O=ar();aW=setTimeout(f.proxy(function(){O=null;aR.trigger("tap",[be.target]);if(au.tap){bc=au.tap.call(aR,be,be.target)}},this),au.doubleTapThreshold)}else{O=null;aR.trigger("tap",[be.target]);if(au.tap){bc=au.tap.call(aR,be,be.target)}}}}else{if(bd==j){if(bb===q||bb===h){clearTimeout(aW);O=null;aR.trigger("doubletap",[be.target]);if(au.doubleTap){bc=au.doubleTap.call(aR,be,be.target)}}}else{if(bd==b){if(bb===q||bb===h){clearTimeout(aW);O=null;aR.trigger("longtap",[be.target]);if(au.longTap){bc=au.longTap.call(aR,be,be.target)}}}}}return bc}function am(){var bb=true;if(au.threshold!==null){bb=ag>=au.threshold}return bb}function ba(){var bb=false;if(au.cancelThreshold!==null&&aP!==null){bb=(aT(aP)-ag)>=au.cancelThreshold}return bb}function ae(){if(au.pinchThreshold!==null){return ap>=au.pinchThreshold}return true}function aA(){var bb;if(au.maxTimeThreshold){if(ac>=au.maxTimeThreshold){bb=false}else{bb=true}}else{bb=true}return bb}function ak(bb,bc){if(au.preventDefaultEvents===false){return}if(au.allowPageScroll===m){bb.preventDefault()}else{var bd=au.allowPageScroll===s;switch(bc){case p:if((au.swipeLeft&&bd)||(!bd&&au.allowPageScroll!=E)){bb.preventDefault()}break;case o:if((au.swipeRight&&bd)||(!bd&&au.allowPageScroll!=E)){bb.preventDefault()}break;case e:if((au.swipeUp&&bd)||(!bd&&au.allowPageScroll!=u)){bb.preventDefault()}break;case x:if((au.swipeDown&&bd)||(!bd&&au.allowPageScroll!=u)){bb.preventDefault()}break}}}function a8(){var bc=aO();var bb=Y();var bd=ae();return bc&&bb&&bd}function aX(){return !!(au.pinchStatus||au.pinchIn||au.pinchOut)}function Q(){return !!(a8()&&aX())}function aV(){var be=aA();var bg=am();var bd=aO();var bb=Y();var bc=ba();var bf=!bc&&bb&&bd&&bg&&be;return bf}function W(){return !!(au.swipe||au.swipeStatus||au.swipeLeft||au.swipeRight||au.swipeUp||au.swipeDown)}function J(){return !!(aV()&&W())}function aO(){return((X===au.fingers||au.fingers===i)||!a)}function Y(){return aQ[0].end.x!==0}function a6(){return !!(au.tap)}function Z(){return !!(au.doubleTap)}function aU(){return !!(au.longTap)}function R(){if(O==null){return false}var bb=ar();return(Z()&&((bb-O)<=au.doubleTapThreshold))}function I(){return R()}function aw(){return((X===1||!a)&&(isNaN(ag)||ag<au.threshold))}function a0(){return((ac>au.longTapThreshold)&&(ag<r))}function ah(){return !!(aw()&&a6())}function aG(){return !!(R()&&Z())}function ao(){return !!(a0()&&aU())}function G(){a5=ar();ay=event.touches.length+1}function S(){a5=0;ay=0}function al(){var bb=false;if(a5){var bc=ar()-a5;if(bc<=au.fingerReleaseThreshold){bb=true}}return bb}function aB(){return !!(aR.data(C+"_intouch")===true)}function an(bb){if(bb===true){aR.bind(ax,a3);aR.bind(V,M);if(T){aR.bind(T,L)}}else{aR.unbind(ax,a3,false);aR.unbind(V,M,false);if(T){aR.unbind(T,L,false)}}aR.data(C+"_intouch",bb===true)}function ai(bd,bb){var bc={start:{x:0,y:0},end:{x:0,y:0}};bc.start.x=bc.end.x=bb.pageX||bb.clientX;bc.start.y=bc.end.y=bb.pageY||bb.clientY;aQ[bd]=bc;return bc}function aH(bb){var bd=bb.identifier!==undefined?bb.identifier:0;var bc=ad(bd);if(bc===null){bc=ai(bd,bb)}bc.end.x=bb.pageX||bb.clientX;bc.end.y=bb.pageY||bb.clientY;return bc}function ad(bb){return aQ[bb]||null}function aI(bb,bc){bc=Math.max(bc,aT(bb));N[bb].distance=bc}function aT(bb){if(N[bb]){return N[bb].distance}return undefined}function ab(){var bb={};bb[p]=av(p);bb[o]=av(o);bb[e]=av(e);bb[x]=av(x);return bb}function av(bb){return{direction:bb,distance:0}}function aM(){return a2-U}function at(be,bd){var bc=Math.abs(be.x-bd.x);var bb=Math.abs(be.y-bd.y);return Math.round(Math.sqrt(bc*bc+bb*bb))}function a7(bb,bc){var bd=(bc/bb)*1;return bd.toFixed(2)}function aq(){if(H<1){return A}else{return c}}function aS(bc,bb){return Math.round(Math.sqrt(Math.pow(bb.x-bc.x,2)+Math.pow(bb.y-bc.y,2)))}function aE(be,bc){var bb=be.x-bc.x;var bg=bc.y-be.y;var bd=Math.atan2(bg,bb);var bf=Math.round(bd*180/Math.PI);if(bf<0){bf=360-Math.abs(bf)}return bf}function aL(bc,bb){var bd=aE(bc,bb);if((bd<=45)&&(bd>=0)){return p}else{if((bd<=360)&&(bd>=315)){return p}else{if((bd>=135)&&(bd<=225)){return o}else{if((bd>45)&&(bd<135)){return x}else{return e}}}}}function ar(){var bb=new Date();return bb.getTime()}function aY(bb){bb=f(bb);var bd=bb.offset();var bc={left:bd.left,right:bd.left+bb.outerWidth(),top:bd.top,bottom:bd.top+bb.outerHeight()};return bc}function F(bb,bc){return(bb.x>bc.left&&bb.x<bc.right&&bb.y>bc.top&&bb.y<bc.bottom)}}}));

function formatNumber(number, decimals, dec_point, thousands_sep) {
	var isInt = (number == Math.round(number));

	var n = !isFinite(+number) ? 0 : +number,
			prec = !isFinite(+decimals) ? (decimals == 'auto' && isInt ? 0 : 2) : Math.abs(decimals),
			sep = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
			dec = (typeof dec_point === 'undefined') ? '.' : dec_point,
			toFixedFix = function (n, prec) {
				// Fix for IE parseFloat(0.55).toFixed(0) = 0;
				var k = Math.pow(10, prec);
				return Math.round(n * k) / k;
			},
			s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split('.');
	if (s[0].length > 3) {
		s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
	}
	if ((s[1] || '').length < prec) {
		s[1] = s[1] || '';
		s[1] += new Array(prec - s[1].length + 1).join('0');
	}
	return s.join(dec);
}

function formatMoney(amount, decimals, decimal_sep, thousands_sep, currency)
{
	/**
	 * [http://stackoverflow.com/questions/21091727/javascript-tofixed-function]
	 */
	amount += 0.00001;

	var c = isNaN(decimals) ? 2 : Math.abs(decimals), //if decimal is zero we must take it, it means user does not want to show any decimal
			d = decimal_sep || ',', //if no decimal separator is passed we use the dot as default decimal separator (we MUST use a decimal separator)

	/*
	 according to [http://stackoverflow.com/questions/411352/how-best-to-determine-if-an-argument-is-not-sent-to-the-javascript-function]
	 the fastest way to check for not defined parameter is to use typeof value === 'undefined'
	 rather than doing value === undefined.
	 */
			t = (typeof thousands_sep === 'undefined') ? '&nbsp;' : thousands_sep, //if you don't want to use a thousands separator you can pass empty string as thousands_sep value

			sign = (amount < 0) ? '-' : '',

	//extracting the absolute value of the integer part of the number and converting to string
			i = parseInt(amount = Math.abs(+amount || 0).toFixed(c), 10) + "",

			j = ((j = i.length) > 3) ? j % 3 : 0;
	var result = sign + (j ? i.substr(0, j) + t : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(amount - i).toFixed(c).slice(2) : '');

	//return result.replace(decimal_sep + '00','');
	if (currency)
		result += '&nbsp;' + currency;

	return result;
}

// Parse Number
function parseNumber(n, dec_point, thousands_sep) {
	n = n.replace(thousands_sep, '');
	n = n.replace(dec_point, '.');

	return parseFloat(n);
}

function fnPageSearch(){
	cssWidth = pdTools.getViewportWidth();
	equalHeights.products.eq(cssWidth);

	$.nette.ext('lazyload').update();

	$.nette.ext('jsTabs').init();

	$.nette.ext('collapsable').init($('#lb-results'));

	$('.ca:not(.ca-slide)').collapsable();
	$('.ca-slide:not(.initialized)').collapsable({
		fx: 'slide',
		onInit: function() {
			$(this).addClass('initialized');
		}
	});
}

// Suggest
(function(e) {
	var t = window.sk = {
		base: {},
		utils: {},
		widgets: {},
		events: {}
	};
	t.extend = function(e, t) {
		var n = function() {};
		n.prototype = t.prototype;
		e.prototype = new n;
		e._super = t.prototype;
		e.prototype.constructor = e
	}
})(jQuery);
(function(e, t) {
	e.widgets.Suggest = function(e, n) {
		this.$input = e.jquery ? e : t(e);
		this.options = t.extend({
			minLength: 2,
			typeInterval: 500,
			url: "/",
			loadingClass: "loading form-input--loading",
			typingClass: "typing form-input--typing"
		}, n);
		this.isResult = false;
		this.typeTimer = null;
		this.searchTerm = "";
		this.ajax = []
	};
	var n = e.widgets.Suggest.prototype;
	n.init = function() {
		this.$input.attr("autocomplete", "off")
			.on("keydown", t.proxy(this.keydown, this))
			.on("keypress", t.proxy(this.keypress, this))
			.on("focus", t.proxy(this.focus, this))
			.on("blur", t.proxy(this.blur, this));
		return this
	};
	n.destroy = function() {
		this.$input.off("keydown", this.keydown).off("keypress", this.keypress).off("focus", this.focus).off("blur", this.blur);
		return this
	};
	n.focus = function() {
		t(this).trigger("suggeststart");
		this.type()
	};
	n.blur = function() {
		t(this).trigger("suggestend");
		this.$input.removeClass(this.options.typingClass)
	};
	n.keydown = function(e) {
		var n = this;
		var r = this.options;
		this.typeTimer = clearTimeout(this.typeTimer);
		this.typeTimer = setTimeout(function() {
			n.type()
		}, r.typeInterval);
		var i = jQuery.Event("typestart", {
			which: e.which
		});
		t(this).trigger(i);
		if (i.isDefaultPrevented()) {
			e.preventDefault()
		} else {
			this.$input.addClass(this.options.typingClass)
		}
	};
	n.keypress = function(e) {
		if (this.$input.val() !== this.searchTerm) {
			this.ajaxAbort()
		}
	};
	n.ajaxRemove = function(e) {
		var t = this.ajax;
		for (var n = 0, r = t.length; n < r; n++) {
			if (t[n] === e) {
				break
			}
		}
		t.splice(n, 1)
	};
	n.ajaxAbort = function() {
		var e = this.ajax;
		for (var t = 0, n = e.length; t < n; t++) {
			e[t].abort()
		}
	};
	n.type = function() {
		var e = this.$input.val();
		var n = this.options;
		if (e !== this.searchTerm) {
			this.searchTerm = e;
			if (e.length >= n.minLength) {
				this.ajaxAbort();
				this.ajax.push(t.ajax({
					type: "GET",
					url: n.url,
					data: this.$input.attr("name") + "=" + e,
					beforeSend: t.proxy(function(e, r) {
						var i = jQuery.Event("beforeSend");
						t(this).trigger(i, [e, r]);
						if (i.isDefaultPrevented()) {
							return false
						}
						this.$input.addClass(n.loadingClass)
					}, this),
					success: t.proxy(function(e, r, i) {
						this.ajaxRemove(i);
						var s = jQuery.Event("success");
						t(this).trigger(s, [e, r, i]);
						this.$input.removeClass(n.loadingClass);
						this.isResult = true
					}, this),
					error: t.proxy(function(e, t, r) {
						this.ajaxRemove(e);
						this.$input.removeClass(n.loadingClass)
					}, this)
				}))
			} else if (this.isResult) {
				this.isResult = false;
				this.ajaxAbort();
				t(this).trigger("typeclear")
			} else {
				t(this).trigger("typeend")
			}
		} else {
			t(this).trigger("typeend")
		}
		this.$input.removeClass(n.typingClass)
	};
	n.clear = function() {
		this.$input.val("");
		this.typeTimer = clearTimeout(this.typeTimer);
		this.type()
	}
})(sk, jQuery);
(function(e, t, n) {
	e.widgets.SuggestMenu = function(e, n, r) {
		this.$element = e.jquery ? e : t(e);
		this.Suggest = n;
		this.options = t.extend({
			item: "li",
			selectedClass: "selected"
		}, r);
		this.$items = t([]);
		this.selectedIndex = 0;
		this.size = 0;
		this.isOpen = false
	};
	var r = e.widgets.SuggestMenu.prototype;
	r.init = function() {
		if (!this.$element.length || this.Suggest === n) {
			return this
		}
		this.$element.hide()
			.on("click", this.options.item, t.proxy(this.handleClick, this))
			.on("mouseenter", this.options.item, t.proxy(this.handleMouseEnter, this));
		t(this.Suggest)
			.on("suggeststart", t.proxy(this.handleSuggestStart, this))
			.on("suggestend", t.proxy(this.handleSuggestEnd, this))
			.on("beforeSend", t.proxy(this.handleBeforeSend, this))
			.on("success", t.proxy(this.handleSuccess, this))
			.on("typestart", t.proxy(this.handleTypeStart, this))
			.on("typeclear", t.proxy(this.handleTypeClear, this));
		this.Suggest.init();
		return this
	};
	r.destroy = function() {
		if (!this.$element.length || this.Suggest === n) {
			return this
		}
		this.$element.hide().empty().off("mouseenter", this.options.item, this.handleMouseEnter).off("click", this.options.item, this.handleMouseEnter);
		t(this.Suggest).off("suggeststart", this.handleSuggestStart).off("suggestend", this.handleSuggestEnd).off("success", this.handleSuccess).off("typestart", this.handleTypeStart).off("typeclear", this.handleTypeClear);
		this.Suggest.destroy()
	};
	r.open = function() {
		if (!this.isOpen && !this.$element.is(":empty")) {
			this.$element.fadeIn(250).addClass('search-suggest--open');
			this.isOpen = true
		}
	};
	r.hide = function(e) {
		if (this.isOpen) {
			if (e) {
				this.$element.hide().removeClass('search-suggest--open')
			} else {
				this.$element.fadeOut(250).removeClass('search-suggest--open')
			}
			this.isOpen = false
		}
	};
	r.handleSuggestStart = function(e) {
		if (this.Suggest.isResult) {
			this.clearIndex();
			this.open()
		}
	};
	r.handleSuggestEnd = function(e) {
		this.Suggest.typeTimer = clearTimeout(this.Suggest.typeTimer);
		this.Suggest.ajaxAbort();
		this.Suggest.$input.removeClass(this.Suggest.options.loadingClass);
		this.hide()
	};
	r.handleSuccess = function(e, n) {
		var r = jQuery.Event("content");
		t(this).trigger(r, [n]);
		if (!r.isDefaultPrevented()) {
			this.$element.html(n)
		}
		this.$items = this.$element.find(this.options.item);
		this.size = this.$items.length + 1;
		this.clearIndex();
		if (this.$element.is(":empty")) {
			this.hide(true)
		} else {
			this.open()
		}
	};
	r.handleTypeStart = function(e) {
		if (e.which === 38) {
			this.handleArrUp(e)
		} else if (e.which === 40) {
			this.handleArrDown(e)
		} else if (e.which === 13 && this.selectedIndex) {
			this.handleEnter(e)
		}
	};
	r.handleTypeClear = function(e) {
		this.hide();
		this.clearIndex()
	};
	r.handleMouseEnter = function(e) {
		if (this.isOpen) {
			this.setIndex(t(e.currentTarget).index() + 1, "enter")
		}
	};
	r.setIndex = function(e, n) {
		var r = this.options;
		if (e !== this.selectedIndex) {
			this.$items.removeClass(r.selectedClass);
			if (e) {
				this.$items.eq(e - 1).addClass(r.selectedClass)
			}
			this.selectedIndex = e;
			t(this).trigger("menuchange")
		}
	};
	r.clearIndex = function() {
		this.$items.removeClass(this.options.selectedClass);
		this.selectedIndex = 0
	};
	r.handleArrUp = function(e) {
		this.setIndex((this.selectedIndex - 1 + this.size) % this.size, "up");
		e.preventDefault()
	};
	r.handleArrDown = function(e) {
		this.setIndex((this.selectedIndex + 1) % this.size, "down");
		e.preventDefault()
	};
	r.handleEnter = function(e) {
		t(this).trigger("menuselect", [{
			type: "enter",
			target: e.target,
		}]);
		e.preventDefault()
	};
	r.handleClick = function(e) {
		this.setIndex(t(e.currentTarget).index() + 1, "click");
		t(this).trigger("menuselect", [{
			type: "click",
			target: e.target,
		}]);
		e.preventDefault()
	}
})(sk, jQuery);


// ***** konec zaklad - opravdu jen zakladni featury

function capitaliseFirstLetter(string) { return string.charAt(0).toUpperCase() + string.slice(1); }

function productListCompare() {
	var $box = $('.compare-group');
	if($box.length == 0)
		return;

	var $items = $box.find('dt .in, dd .in');
	$items.css('height', '');

	$box.each(function() {
		var $activeBox = $(this);

		$activeBox.find('.compare-part:not(.compare-part-products)').each(function() {
			var $comparePart = $(this);
			var rowHeight = new Array();

			$comparePart.find('.item-col').each(function(k) {
				var $col = $(this);
				$col.find('dt .in').each(function(i) {
					if(k == 0) {
						rowHeight[i] = $(this).height();
					} else {
						if($(this).height() > rowHeight[i]) {
							rowHeight[i] = $(this).height();
						}
					}
				});
				$col.find('dd .in').each(function(i) {
					if($(this).height() > rowHeight[i]) {
						rowHeight[i] = $(this).height();
					}
				});
			});
			$comparePart.find('.item-col').each(function() {
				var $col = $(this);
				$col.find('dt .in').each(function(i) {
					$(this).height(rowHeight[i]);
				});
				$col.find('dd .in').each(function(i) {
					$(this).height(rowHeight[i]);
				});
			});
		});
	});
}

document.dispatchEvent(new CustomEvent('mainJsDone'));

var cssWidth = 0;

$(document).ready(function(){

	var $w = $(window);
	var viewportWidth = 0;
	var oldWidth = 0;
	var sidebarChange = true; // jestli se přepnulo zobrazení sidebar panelu, na něm závisí ca boxy ca-alt; výchozí hodnota true, aby se při načtení inicializovali boxy
	// Detail produktu horní lišta
	var $navbarHolder = $('#navbar-holder');
	var navbarHeight = $navbarHolder.outerHeight(true);
	var $body = $('body');

	$body.data('filter', []);

	var $html = $('html');
	var langcode = $html.attr('lang') || 'cs';
	var langs = {
		cs: { close: "Zavřít", prev: "předchozí", next: "další" },
		en: { close: "Close", prev: "previous", next: "next" },
		de: { close: "Zumachen", prev: "vorige", next: "folgend" },
		es: { close: "Vaer", prev: "previo", next: "siguiente" },
		fr: { close: "Fermer", prev: "précédant", next: "suivant" },
		it: { close: "Chiudere", prev: "previo", next: "veniente" },
		sk: { close: "Zavrieť", prev: "predchádzajúca", next: "ďalšie" },
		bg: { close: "закрыть", prev: "предишна", next: "следваща" },
		ro: { close: "Închide", prev: "anterior", next: "următor" },
		sr: { close: "Zatvori", prev: "prethodna", next: "sledeći" }
	};

	var prevControl = langs[langcode]["prev"];
	var nextControl = langs[langcode]["next"];

	$('.reference-list').each(function() {
		var $this = $(this);

		var $carousel = $this.find('.reference-list__list');
		var $paging = $('<nav aria-label="Carousel pagination"><ul class="carousel-paging references"></ul></nav>');

		$this.append($paging);

		$carousel.carouFredSel({
			circular: true,
			infinite: true,
			responsive: true,
			items: {
				visible: {
					min: 1,
					max: 5
				},
			},
			auto: {
				play: false,
				pauseOnHover: true,
				timeoutDuration: 4000
			},
			pagination: {
				container: $paging.find('ul'),
				anchorBuilder: function(nr) {
					return `<li>
								<a class="cursor-pointer" type="button" aria-label="Slide ${nr}" aria-hidden="true">${nr}</a>
							</li>`;
				}			
			}

		});
	});

	$('.fade-carousel')
		.each(function() {
			var $this = $(this);
			$this.find('.carousel-paging').remove();

			var $carousel = $this.find('.carousel-ul');

			var $paging = $('<span class="carousel-paging"></span>');

			$this.append($paging);

			$carousel.carouFredSel({
				circular: true,
				infinite: true,
				responsive: true,
				width: '100%',
				height: 'auto',
				items: {
					height: 'auto',
					visible: {
						min:1,
						max:1
					}
				},
				scroll: {
					fx: 'crossfade'
				},
				auto: {
					play: true,
					timeoutDuration: 6000
				},
				pagination: $paging.filter('.carousel-paging')
			});
		})
		.on('recalculate', function(e) {
			var $wrap = $(this).find('.caroufredsel_wrapper');
			var $carousel = $(this).find('.carousel-ul');

			$carousel.addClass('updateSizes');

			$carousel.trigger('updateSizes');
			$wrap.css('height', $carousel.height());

			$carousel.removeClass('updateSizes');
		});

	function detailImagesInit() {
		$('.product-images.carousel:not(.initialized)').each(function() {
			var $mainImages = $(this).find('.main-images');
			var $mainCarousel = $mainImages.find('ul.reset');

			$mainImages.addClass('initialized');

			var $prev = $('<a href="#" class="prev" title="' + prevControl + '"><span>' + prevControl + '</span></a>');
			var $next = $('<a href="#" class="next" title="' + nextControl + '"><span>' + nextControl + '</span></a>');
			var $pager = $('<p class="reset pager"></p>');

			$mainImages.append($prev, $next, $pager);

			$mainCarousel.carouFredSel({
				responsive: true,
				infinite: false,
				circular: true,
				items: {
					visible: 1,
					width: 588,
					height: '78%'
				},
				auto: false,
				prev: {
					button: $prev,
					key: 'left'
				},
				next: {
					button: $next,
					key: 'right'
				},
				pagination: {
					container: $pager
				}
			});
		});
	};
	detailImagesInit();

	(function(){
		cssWidth = pdTools.getViewportWidth();
		viewportWidth = $w.width();

		var $footer = $('#footer');
		var $products = $('.products:not(.lv-products, .f-products, .variant-products, .qa-products, .rc-products, .quantity-products, .brand-products)');
		var $productDesc = $('.product-desc');
		var $orderCross = $('.order-cross');
		var $navbarHolder = $('#navbar-holder');
		var $sort = $('#sort');
		var $colSide = $('#col-side');
		var navbarHeight = $navbarHolder.outerHeight(true);

		var timer = null,
			levels = [
				{
					from: 0,
					to: 599,
					callback: function(){
						if(cssWidth >= 480) {
							multiactionProducts.init(2);
						} else {
							multiactionProducts.init(0);
						}

						$('#ask-pharmacist-side').filter('.ca-expanded').each(function() {
							$('.hp-add-question a').trigger('click');
						});
					}
				},
				{
					from: 600,
					to: 767,
					callback: function(){
						multiactionProducts.init(2);

						$('#ask-pharmacist-side').filter('.ca-expanded').each(function() {
							$('.hp-add-question a').trigger('click');
						});
					}
				},
				{
					from: 768,
					to: 899,
					callback: function(){
						navbarInit();
						multiactionProducts.init(3);
					}
				},
				{
					// >= 900
					callback: function(){
						navbarInit();
						drawFigure();
						multiactionProducts.init(3);
					}
				}
			];

		$(window).bind('resize firstcall ajaxReload', function(e) {
			timer = clearTimeout(timer);
			timer = setTimeout(function() {
				cssWidth = pdTools.getViewportWidth();
				viewportWidth = $w.width();
				var locHash = window.location.hash;

				if( (oldWidth !== cssWidth) || (e.type === 'ajaxReload') ) {
					equalHeights.eq(cssWidth);

					$footer = $('#footer');
					$products = $('.products:not(.full-products, .lv-products, .f-products, .variant-products, .qa-products, .rc-products, .quantity-products, .brand-products)');
					$productDesc = $('.product-desc');
					$orderCross = $('.order-cross');
					$navbarHolder = $('#navbar-holder');
					$sort = $('#sort');
					$colSide = $('#col-side');
					navbarHeight = $navbarHolder.outerHeight(true);

					$('.benefit-box, #col-side, .hp-find-closest, .f-eq-box, .f-eq-link').attr('style', '');

					$('.fade-carousel').trigger('recalculate');
					$('.hp-carousel, .hp-actions').each(function() {
						$(this).find('ul.reset').trigger("destroy");
						$(this).find('.next, .prev, .pager').remove();
					});
					drawInteraction();


					// Přechod tablet <-> desktop
					if (oldWidth < 768 && cssWidth >= 768) {
						if (($sticky = $('.fixed-side-menu')).length > 0) {
							$sticky.stick_in_parent({
								offset_top: 0,
								inner_scrolling: false,
								parent: '.columns-layout'
							});
						}
					}
					else if (cssWidth < 768)  {
						if (($sticky = $('.sticky')).length > 0) {
							$sticky.removeAttr('style').trigger('sticky_kit:detach');
						}
					}

					for(var i = 0, l = levels.length; i < l; i++ ) {
						if( i === l-1 || levels[i].from <= cssWidth && cssWidth <= levels[i].to ) {
							levels[i].callback();
							break;
						}
					}

					oldWidth = cssWidth;
					sidebarChange = false;
				}
			}, 200);
		})
		.triggerHandler('firstcall');
	})(); // end width check

	$('input[required], input[type=email]').each(function() {
		$(this).bind('change', function() {
			if($(this).val() == '')
				$(this).addClass('empty');
			else
				$(this).removeClass('empty');
		}).triggerHandler('change');
	});

	// STEPS LIST
	$('#step-list').each(function(){
		var $prev = $('li.prev', this);
		var $next = $('li.next', this);

		var $btnNext = $('.buttons .next-step');
		var $btnPrev = $('.buttons .prev-step');

		$next.click(function(){
			$btnNext.trigger('click');
		});
		$prev.click(function(){
			window.location = $btnPrev.attr('href');
		});
	});

	$('.ca:not(.ca-slide):not(.ca--responsive-md)').collapsable()
	$('.ca--responsive-md').collapsable({
		responsive: {
			enabled: true,
			breakpoint: 768
		}
	})

	$('.expand-box')
		.filter(function() {
			return ! $(this).data('initialized');
		})
		.each(function() {
			var $box = $(this);

			$box.data('initialized', true);

			if($box.find('.expand-content').length) {
				$box
					.on('expand.collapsable', function() {
						var $control =  $(this).find('.expand-control a');
						var $controlSpan = $control.find('span');
						$controlSpan.text($control.data('collapse'));
					})
					.on('collapse.collapsable', function() {
						var $control =  $(this).find('.expand-control a');
						var $controlSpan = $control.find('span');
						$controlSpan.text($control.data('expand'));
					})
					.on('collapsed.collapsable', function(e) {
						if( (e.collapsableEvent.type !== 'init.collapsable') && $box.data('scroll-on-collapse')) {
							var id = $box.data('scroll-parent');
							var offsetTop = 10;

							if( $('#navbar-holder').length && ($('#navbar-holder').offset().top < $box.offset().top) ) {
								offsetTop += $('#navbar-in').outerHeight();
							}

							smoothScroll.animateScroll(id, null, { updateURL: false, offset: offsetTop });
						}
					})
					.collapsable({
						control: '.expand-control a',
						box: '.expand-content',
						fx: 'slide'
					})
			}
		});

	$('.ca-comment-form').collapsable({
		control: '.ca-comment-control',
		box: '.ca-comment-box',
		fx: 'slide',
		extLinks: {
			selector: '.ca-comment-form-ext',
			preventDefault: true
		}
	});

	openBox.init();

	// Rozbaleni anotace
	$('#page-head').find('input').on('change', function() {
		var $box = $(this).closest('#page-head');
		$box.toggleClass('annot-expanded').find('#annot').slideToggle();
	});

	// STAR RATING
	$('.total-rating').each(function() {
		var $rate = $(this).find('.rate');
		var $value = $(this).find('.value input');

		if($value.val()){
			$rate.addClass('star-width-'+$value.val());
		}

		$rate.find('.part').hover(function(){
			var value = $(this).html();
			$rate.addClass('hover-star-'+value);
		}, function() {
			var value = $(this).html();
			$rate.removeClass('hover-star-'+value);
		});

		$rate.find('.part').on('click', function() {
			var value = $(this).html();
			for(var i=1;i <=5; i++) {
				$rate.removeClass('star-width-'+i);
			}
			$rate.addClass('star-width-'+value);
			$value.val(value);
		});
	});

	function navbarInit() {
		var areas = new Array();
		navbarAreas();

		// Konstrukce pole areas
		function navbarAreas() {
			$('#navbar').each(function() {
				var $links = $('a:visible:not(.navbar-ext)', '#navbar');
				$links.each(function(i) {
					var id = $(this).attr('href');
					areas.push({ 'offset': Math.floor($(id).offset().top) - navbarHeight, 'id': id});
				});
			});
		}

		// Funkce oznaci aktivni polozku navbaru dle aktualni pozice dokumentu a pole areas
		var markActive = function() {
			var scroll = $(document).scrollTop();
			var minID = null;
			var minDist = Infinity;
			for(i in areas) {
				if( (scroll+navbarHeight) >= areas[i].offset && (scroll + navbarHeight - areas[i].offset) < minDist) {
					minDist = (scroll - areas[i].offset);
					minID = areas[i].id;
				}
			}
			$el = $('a[href="' + minID + '"]', '#navbar');
			if(!$el.hasClass('active')) {
				$('.active', '#navbar').removeClass('active');
				$el.addClass('active');
			}
		};

		$navbarHolder.each(function() {
			var $holder = $(this);
			var $navbar = $('#navbar-in');
			var top = Math.round($holder.offset().top);
			var w = 0;
			var navbarPadding = $navbar.outerWidth() - $navbar.width();
			var t = null;
			var fade = $holder.find('.fade');
			setTimeout(function() {
				top = Math.round($holder.offset().top);
				navbarPadding = $navbar.outerWidth() - $navbar.width();
				w = $holder.width() - navbarPadding;
				$navbar.css('width', w);
			}, 500);

			$(window).on('resize', function() {
				clearTimeout(t);
				t = setTimeout(function() {
					top = Math.round($holder.offset().top);

					navbarPadding = $navbar.outerWidth() - $navbar.width();
					w = $holder.width() - navbarPadding;

					$navbar.css('width', w);
					navbarAreas();

					$(window, document).triggerHandler('scroll');
				}, 100);
			}).triggerHandler('resize');

			$(window, document).scroll(function() {
				top = Math.round($holder.offset().top);
				var scroll = $(document).scrollTop();

				markActive();
				if(scroll > top) {
					$holder.addClass('fixed-navbar');
					if(!fade.data('shown')) {
						fade.data('shown', true).show();
						t = setTimeout(function() {
							fade.stop().fadeTo(0, 1).fadeOut('fast');
						}, 500);
					}
				}
				else {
					$holder.removeClass('fixed-navbar');
					clearTimeout(t);
					fade.data('shown', false).hide();
				}
			});
		});
	}

	$(document).on('click', '.anchor:not(.pdbox__window .anchor), .scroll a:not(.pdbox__window .scroll a), .context-menu a:not(.pdbox__window .context-menu a)', function(e){
		var $link = $(this);
		var id = $link.attr('href');
		if(id.indexOf("#") > -1) {
			var $el = $(id);
			var dataOffset = $link.data('offset');
			var offsetTop = 0;
			if( $('#navbar-holder').length && ($('#navbar-holder').offset().top < $el.offset().top) ) {
				offsetTop = $('#navbar-in').outerHeight();
			}
			if (typeof dataOffset != 'undefined') {
				offsetTop += dataOffset;
			}
			smoothScroll.animateScroll(id, null, { offset: (cssWidth < 768 ? offsetTop+50 : offsetTop) });
			e.preventDefault();
		}
	});

	$(document).on('click', '.pdbox__window .anchor, .pdbox__window .scroll a, .pdbox__window .context-menu a', function(e) {
		var id = $(this).attr('href');
		if(id.indexOf("#") > -1) {
			var $pdWindow = $('.pdbox__window');
			var $el = $pdWindow.find(id);
			var scrollTo = parseInt($el.offset().top - $pdWindow.offset().top + $pdWindow.scrollTop());

			$pdWindow.stop().animate({
				scrollTop: scrollTo
			}, 500, function() {
				//animation finished
			});
			e.preventDefault();
		}
	});

  // Add click event to all anchor links so that focus is moved to the target element for accessibility
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      const targetId = this.getAttribute('href').slice(1);
      const targetEl = document.getElementById(targetId);

      if (targetEl) {
        // Set tabindex, if needed
        if (!targetEl.hasAttribute('tabindex')) {
          targetEl.setAttribute('tabindex', '-1');
        }

        // Set focus
        targetEl.focus();
      }
    });
  });


	// SmoothScroll
	smoothScroll.init({
		offset: 15
	});

	$(document).on('change', '.career-map select', function() {
		$('.area'+$(this).val()).click();
	});

	$('.career-map area').hover(
		function() {
			var $this = $(this);
			$('.career-map').find('.num'+$this.data('box')).addClass('hover');
		}, function() {
			var $this = $(this);
			$('.career-map').find('.num'+$this.data('box')).removeClass('hover');
		}
	);

	var $points = $('#points');
	$points.find('.point').hover(function(){
		$('#'+$(this).attr('rel')).find('a').addClass('hover');
	}, function() {
		$('#'+$(this).attr('rel')).find('a').removeClass('hover');
	});

	var drawInteraction = function() {
		if(pdTools.getViewportWidth() > 767) {
			$('.js-interaction').each(function() {
				var $interaction = $(this),
					$products = $interaction.find('.js-sub-product .interaction-result__dot'),
					canvas = $interaction.find('canvas')[0],
					ctx = canvas.getContext("2d"),
					$root = $interaction.find('.interaction-dot--main'),
					rootPos = [];

				rootPos[0] = parseInt(($root.offset().left - $interaction.offset().left) + parseInt($root.width()/2));
				rootPos[1] = parseInt(($root.offset().top - $interaction.offset().top) + parseInt($root.height()/2));

				canvas.width = $interaction.width();
				canvas.height = $interaction.height();

				ctx.clearRect(0, 0, canvas.width, canvas.height);
				ctx.lineWidth = 2;

				$products.each(function() {
					var $product = $(this);
					var productPos = [];

					productPos[0] = parseInt(($product.offset().left - $interaction.offset().left) + 2);
					productPos[1] = parseInt(($product.offset().top - $interaction.offset().top) + parseInt($root.height()/2));

					ctx.strokeStyle = $product.css('background-color');

					ctx.beginPath();
					ctx.moveTo(rootPos[0], rootPos[1]);
					ctx.lineTo(productPos[0], productPos[1]);
					ctx.stroke();
				});
			});
		}
	};

	$('.js-tooltip').each(function() {
		var $el = $(this);

		$el.tooltip({
			items: "[data-tooltip]",
			tooltipClass: $el.data('tooltip-class'),
			position: {
				my: $el.data('tooltip-position-my') || 'center top',
				at: $el.data('tooltip-position-at') || 'center bottom+7',
				using: function(position, feedback) {
					$(this).css(position)
						.addClass(feedback.vertical)
						.addClass(feedback.horizontal);
				}
			},
			content: function () {
				var tooltipSelector = $el.data('tooltip');
				var $tooltip = tooltipSelector ? $(tooltipSelector) : $([]);
				return $tooltip.length ? $tooltip.html() : '';
			}
		});
	});

	$('.radio-list-simple').find('input:radio').not('.jsTransport input, .jsPayment input').on('change', function(e) {
		$(this).closest('.radio-list-simple').find('.show-detail').removeClass('show-detail');
		$(this).closest('li').addClass('show-detail');
	});

	function drawFigure() {
		$('#pain-cross').each(function() {
			var $box = $(this).find('.pain-illust');
			var canvas =  document.getElementById("canvas");
			var ctx = canvas.getContext("2d");
			var connectors = [];

			canvas.width = $box.width();
			canvas.height = $box.height();
			ctx.lineWidth = 1;
			ctx.strokeStyle = '#c3c8d9';

			$box.find('.points .point').each(function() {
				var $point = $(this);
				var $link = $('#'+$point.attr('rel'));
				var $start;
				var $end;

				if($link.closest('li').hasClass('even')) {
					$start = $point;
					$end = $link;
				} else {
					$start = $link;
					$end = $point;
				}

				connectors.push({
					from: $start,
					to: $end
				});
			});

			connect();

			function connect() {
				ctx.clearRect(0, 0, canvas.width, canvas.height);
				for (var i = 0; i < connectors.length; i++) {
					var c = connectors[i];
					var eFrom = c.from;
					var eTo = c.to;

					var pos1 = eFrom.position();
					var pos1left;
					var pos1top;

					if(eFrom.hasClass('point')) {
						pos1left = $points.position().left + parseInt($points.css('margin-left')) + eFrom.position().left + parseInt(eFrom.outerWidth()/2);
					} else {
						pos1left = pos1.left + eFrom.width() + 36;
					}

					if(eFrom.hasClass('point')) {
						pos1top = $points.position().top + parseInt($points.css('margin-top')) + eFrom.position().top + parseInt(eFrom.outerHeight()/2);
					} else {
						pos1top = pos1.top + parseInt(eFrom.css('margin-top')) + parseInt(eFrom.find('.title').height()/2);
					}


					var pos2 = eTo.position();
					var pos2left;
					var pos2top;

					if(eTo.hasClass('point')) {
						pos2left = $points.position().left + parseInt($points.css('margin-left')) + eTo.position().left + parseInt(eTo.outerWidth()/2);
					} else {
						pos2left = eTo.position().left + 20 + parseInt(eTo.css('padding-left')) - 36;
					}

					if(eTo.hasClass('point')) {
						pos2top = $points.position().top + parseInt($points.css('margin-top')) + eTo.position().top + parseInt(eTo.outerHeight()/2);
					} else {
						pos2top = pos2.top + parseInt(eTo.css('margin-top')) + parseInt(eTo.find('.title').height()/2);
					}

					ctx.beginPath();
					ctx.moveTo(pos1left, pos1top);
					ctx.lineTo(pos2left, pos2top);
					ctx.stroke();


					ctx.beginPath();
					if(!eFrom.hasClass('point')) {
						ctx.moveTo(pos1left, pos1top);
						ctx.lineTo(pos1left - 36, pos1top);
					} else {
						ctx.moveTo(pos2left, pos2top);
						ctx.lineTo(pos2left + 36, pos2top);
					}
					ctx.stroke();

				}
			}
		});
	}

	/* Zavírání všeho možného při kliku do stránky */
	window.$closeThisStuffOnHtmlClickOrTap = {
		caDropdown: $('.js-collapsable-dropdown')
	};
	$('html').on('click tap', function(e) {
		// Pokud klikáme v pdboxu, nechceme zavírat nic pod ním
		if ($body.hasClass('pdbox-open')) {
			return;
		}

		for (var i in $closeThisStuffOnHtmlClickOrTap) {
			if($closeThisStuffOnHtmlClickOrTap.hasOwnProperty(i)) {
				if ($closeThisStuffOnHtmlClickOrTap[i].has(e.target).length === 0) {
					$closeThisStuffOnHtmlClickOrTap[i].collapsable('collapseAll');
				}
			}
		}
	});

	customSelect.init();
	flashMessages.init();

	$('select#variant').on('jsChange', function() {
		var id = $(this).val();
		if (id != 'default-variant') {
			document.location = $('#' + id).attr("href");
		}
	});

	$('.order-list').find('.show a').on('click', function(e) {
		var $this = $(this);
		var newText = $this.data('text');
		$this.closest('tbody').find('.order').fadeToggle();
		$this.data('text', $this.html()).html(newText);
		e.preventDefault();
	});

	$('.ext').on('click', function(e) {
		window.open(this.href);
		e.preventDefault();
	});

	$('.map-holder').each(function() {
		var $box = $(this);
		var $mapAreas = $box.find('area');
		$mapAreas.hover(function() {
			var $target = $('.area'+$(this).data('box'));
			$target.addClass('jsHover');
		}, function() {
			var $target = $('.area'+$(this).data('box'));
			$target.removeClass('jsHover');
		});

	});

	$(document).on('click', '.add-question a', function(e) {
		e.preventDefault();

		var $box = $('#ask-pharmacist-side');

		if($box.length) {
			$box.collapsable('expandAll');

			if (cssWidth < 768) {
				var top = $(this).offset().top - $box.outerHeight() - 25;

				$box.css('top', top);
				$('html, body').stop().animate({
					scrollTop: top - 40
				}, 500, function() {
					$box.find('.javaScriptFocus').focus();
				});
			}
			else {
				$box.find('.javaScriptFocus').focus();
			}
		}
	});

	$('.recipe-items').find('input:checked').each(function() {
		var $box = $(this).closest('label');
		var $inp = $box.closest('.recipe-items-holder').find('.inp-number').detach();
		$box.append($inp);
	});


	$('input.datepicker').not('.future-only')
		.attr('type', 'text')
		.attr('autocomplete', 'off')
		.datepicker({
			changeMonth: true,
			changeYear: true,
			yearRange: "1920:+0",
			dateFormat: "d. m. yy",
			onClose: function() {
				this.dispatchEvent(new CustomEvent('validate', { bubbles: true }));
			}
		});

	$('input.datepicker.future-only').datepicker({
		changeMonth: true,
		changeYear: true,
		minDate: +1,
		dateFormat: "d. m. yy",
		onClose: function() {
			this.dispatchEvent(new CustomEvent('validate', { bubbles: true }));
		}
	});


	contextMenu.init();
	iconContextMenu.init();

	// nette.ajax.js
	if (historyExt = $.nette.ext('history')) {
		historyExt.cache = false;
	}

	var initExt = $.nette.ext('init')
	initExt.linkSelector = 'a.legacy-ajax';
	initExt.formSelector = 'form.legacy-ajax';
	initExt.buttonSelector = 'input.legacy-ajax[type="submit"], form.legacy-ajax input[type="submit"], button.legacy-ajax[type="submit"], form.legacy-ajax button[type="submit"], input.legacy-ajax[type="image"], form.legacy-ajax input[type="image"]';
	$.nette.init();

	// detekce změny velikosti
	var erd = elementResizeDetectorMaker({
		strategy: 'scroll'
	});
	var sticky_debounce = null;

	erd.listenTo($('.group-content'), function(element) {
		clearTimeout(sticky_debounce);
		sticky_debounce = setTimeout(function() {
			$(document.body).trigger("sticky_kit:recalc");
		}, 100);
	});

	//Poradna thickbox
	$('#btn1').click(function() {
		var $li = $(this);
		if(!$li.hasClass('active')) {
			$li.addClass('active').siblings().removeClass('active');
		} else {
			$li.removeClass('active');
		}
	});

	$(".js-btn-info-check").each(function() {
		var $wrap = $(this);
		var $btn = $wrap.find('.js-btn-info-check__btn');
		var $box = $wrap.find('.js-btn-info-check__box');
		var $reqCheckbox = $wrap.find('input[type="checkbox"]');

		$btn.on('mouseenter', function(e) {
			if ( ! $reqCheckbox.is(':checked') ) {
				$box.addClass('btn-info-wrap__box--wobble');
			}
		});
		$btn.on('mouseleave', function(e) {
			$box.removeClass('btn-info-wrap__box--wobble');
		});

	});

	const toggleAriaHiddenByClass = (selector) => {
		const el = document.querySelector(selector);
		const isMobile = window.innerWidth < 1024;
	
		if (!el) return;
	
		if (isMobile) {
			el.setAttribute('aria-hidden', 'true');
		} else {
			el.removeAttribute('aria-hidden');
		}
	};
	
	const updateAriaHidden = () => {
		toggleAriaHiddenByClass('.dropdown__box.ca-box');
		toggleAriaHiddenByClass('.filter-layout__filter-content.ca-box');
	};
	
	window.addEventListener('resize', updateAriaHidden);
	updateAriaHidden();

	const tagListArticles = document.querySelector('.tags-list__list.tags-list__list--center');
	if(tagListArticles) {
		tagListArticles.removeAttribute('aria-hidden');
	}
});

const closeFlashMessage = (message) => {
	setTimeout(() => {
		if (message) {
			message.remove();
		}
	}, 8000);
};

var flashMessages = {
	init: function() {
		const snippetsExt = $.nette.ext('snippets');
		
		if (!snippetsExt) {
			return;
		}

		snippetsExt.after(($el) => {
			$el.find('.message').each((_, element) => {
				closeFlashMessage(element);
			});
		});
	}
};

var customSelect = {
	init: function() {
		$(".custom-select:not(.initialized)").each(function() {
			var ddData = [];
			var $this = $(this);
			var $select = $this.find('select');
			var placeholderID = '#' + $select.data('placeholder-id');
			var init = true;

			$this.addClass('initialized');
			$this.find('option').each(function(i) {
				var o = new Object();
				var $this = $(this);

				o.text = String($this.data('text'));
				o.value = String($this.attr('value'));
				o.selected = (typeof $this.attr('selected') !== 'undefined') ? true : false;
				o.description = $this.data('description') || '';
				o.imageSrc = null;

				ddData.push(o);
			});

			$(placeholderID).ddslick({
				data: ddData,
				width: 'auto',
				onSelected: function(dd) {
					if (!init) {
						$select.val(dd.selectedData.value);
						$select.trigger('jsChange');
					}
					init = false;
				}
			});

			$select.change(function() {
				$(placeholderID).ddslick('select', { index: String($(this)[0].selectedIndex) }); // ten plugin psal blbec, když pošlu 0 jako číslo, tak to nefunguje (protože 0 je false), proto je potřeba posílat jako string!
			});
		});
	}
};

var openBox = {
	init: function() {
		$('.open-box:not(.initialized)').each(function(){
			var $this = $(this);
			var $chck = $('.heading input', this);
			var $box = $('.box', $this);
			var boxHeight = $box.height();
			var attr = $chck.is(':checked');
			var size = 0;

			$this.addClass('initialized');
			$('.box :input', $this).each(function(){
				if($(this).is(':text') && $(this).val() != '' && ( ($(this).data('nette-empty-value') !== 'undefined') && ($(this).data('nette-empty-value') != $(this).val()) ) )
				{
					size++;
				}
				else if($(this).attr('checked'))
				{
					if($(this).val()!=0)
					{
						size++;
					}
				}
			});

			if(attr || (size != 0 && !$this.hasClass('notAutoOpen')))
			{
				$chck.attr('checked', true);
				$this.data('status', true);
				$('.heading', $this).addClass('open');
			}
			else
			{
				$box.hide();
				$this.data('status', false);
				$('.heading', $this).removeClass('open');
			}

			$chck.click(function(){
				if($this.data('status'))
				{
					$chck.attr('checked', false);
					$box.slideUp('fast');
					$this.data('status', false);
					$('.heading', $this).removeClass('open');
				}
				else
				{
					$chck.attr('checked', true);
					$box.slideDown('fast');
					$this.data('status', true);
					$('.heading', $this).addClass('open');
				}
			});
		});
	}
};

var multiactionProducts = {
	init: function(itemNo) {
		var lazyloadExt = $.nette.ext('lazyload');

		$('.ma-products').each(function() {
			var $this = $(this).find('.quantity-products');
			var h = $this.find('.ma-item').first().outerHeight(true);

			if(itemNo)
				h += $this.find('.ma-item').eq(itemNo).outerHeight(true);

			$this.css('max-height', h+'px');

			// Nemůže být uvnitř lazyload.ajax.js kvůli tomu max-height, které se nastaví později - do té doby container
			// nescrolluje. Krom toho je trochu problém s tím, že container je dynamicky vytvářený ve snippetu (ale to
			// se dá řešit i v tom lazyload.ajax.js, byť trochu komplikovaněji)
			new LazyLoad(
				$.extend({}, lazyloadExt.settings, {
					elements_selector: '.js-lazy',
					thresholds: lazyloadExt.thresholds,
					container: this
				})
			);
		});
	}
};

function orderWarehouseListOpenBox(lazymap) {
	/* skrývání / zobrazování detailu prodejny v reklamaci */
	var $optionsList = $('.warehouse-options-list');

	$optionsList.find('input:radio').off("change.optionsList init.optionsList").on('change.optionsList init.optionsList', function (e) {
		var $method = $(this).closest('li');
		var $oldMethod = $(this).closest('.radio-list-simple').find('> .show-detail');

		$oldMethod.removeClass('show-detail');
		$method.addClass('show-detail');

		// Dirty fix for Seznam maps tiles rendering
		var resizeEvent = new Event('resize');
		window.dispatchEvent(resizeEvent);

		var $cashDefaultDescription = $('#js-default-payment-description');
		var $cashDefaultTitle = $('#js-default-payment-title');
		var $cashDynamictTitle = $('#js-dynamic-payment-title');

		$cashDefaultDescription.show();
		$cashDefaultTitle.show();
		$cashDynamictTitle.hide().html('');

		if($method.find('.warehouse-detail').length) {
			var $paymentOptions = $method.find('.warehouse-payment-options');

			var paymentSuffix = '';
			if (typeof $paymentOptions.data('suffix') !== 'undefined'){
				paymentSuffix = $paymentOptions.data('suffix');
			}

			var $desc = $paymentOptions.clone();
			var options = [];
			var text = '';

			$desc.find('.payment-options-title, .payment-options-info, .payment-option-no').remove();
			$desc.find('.payment-option').each(function() {
				options.push($(this).text());
			});
			text = options.join(', ');

			if (paymentSuffix) {
				text += ' ' + paymentSuffix;
			}

			if (text) {
				$cashDefaultDescription.hide();
				$cashDefaultTitle.hide();
				$cashDynamictTitle.show().html(text);
			}
		}
	});

	$(document).ajaxComplete(function() {
		var $method = $optionsList.find('input[type="radio"]:checked').closest('li');
		if ($method.length) {
			$method.addClass('show-detail');
		}
	});
}

var contextMenu = {
	init: function() {
		$('.context-menu.hidden').each(function () {
			var $this = $(this);
			// ODSTRANĚNÍ DIAKRITIKY
			var sdiak = "áäčďéěíĺľňóôöŕšťúůüýřžÁÄČĎÉĚÍĹĽŇÓÔÖŔŠŤÚŮÜÝŘŽ/";
			var bdiak = "aacdeeillnooorstuuuyrzAACDEEILLNOOORSTUUUYRZ.";

			function bezdiak(str) {
				var tx = "";
				var txt = str;
				for (var p = 0; p < txt.length; p++) {
					if (sdiak.indexOf(txt.charAt(p)) != -1) {
						tx += bdiak.charAt(sdiak.indexOf(txt.charAt(p)))
					} else tx += txt.charAt(p)
				}
				return tx;
			};

			var $links = '';
			$('h2', $('#col-content').find('.page-anchor-wrap')).each(function(){
				var $item = $(this);
				var arr = $item.data('context') ? $item.data('context') : $item.find('.name').text();
				var name = $item.data('context') ? $item.data('context') : $item.find('.name').text();
				arr = bezdiak(arr.toLowerCase());
				arr = arr.replace(/\s/g, "-").replace(/[-]{2,}/g, "-").replace(/\.|\,|\>|\<|\"|\'|\`|\%|\!|\?|\{|\}|\(|\)|\[|\]|\\|@|:|/g, "").replace(/^-/, "").replace(/-$/, "");
				$item.attr('id', "toc-" + arr);
				$links += "<li class='group'><i class='absolute left-6 top-6 u-c-default-page !text-[11px] icon-hospital-cross group-hover:scale-125' aria-hidden='true'></i><a href='#toc-" + arr + "'>"+ name +"</a></li>";
			});

			$(this).find('ul').prepend($links);
			if($links.length) $(this).removeClass('hidden');
		});
	}
};

var iconContextMenu = {
	init: function() {
		var pageAnchorWrap = $('.page-anchor-wrap');
		var moreInfoLabel = pageAnchorWrap.data('more-info');

		$('.page-anchor-icons.hidden').each(function () {
			var $this = $(this);
			// ODSTRANĚNÍ DIAKRITIKY
			var sdiak = "áäčďéěíĺľňóôöŕšťúůüýřžÁÄČĎÉĚÍĹĽŇÓÔÖŔŠŤÚŮÜÝŘŽ/";
			var bdiak = "aacdeeillnooorstuuuyrzAACDEEILLNOOORSTUUUYRZ.";

			function bezdiak(str) {
				var tx = "";
				var txt = str;
				for (var p = 0; p < txt.length; p++) {
					if (sdiak.indexOf(txt.charAt(p)) != -1) {
						tx += bdiak.charAt(sdiak.indexOf(txt.charAt(p)))
					} else tx += txt.charAt(p)
				}
				return tx;
			};

			var $list = $('<ul></ul>');
			var $links = '';
			$('h2', $('.page-anchor-wrap.wysiwyg')).each(function(){
				var $item = $(this);
				var $context = $item.data('context');
				if ($context === undefined) {
					return;
				}

				var arr = $context ? $context : $item.find('.name').text();
				var name = $context ? $context : $item.find('.name').text();
				var icon = $item.find('.anchor-ico').clone();
				icon.find('img').attr('alt', '');
				var iconHtml = $('<div></div>').append(icon).html();

				arr = bezdiak(arr.toLowerCase());
				arr = arr.replace(/\s/g, "-").replace(/[-]{2,}/g, "-").replace(/\.|\,|\>|\<|\"|\'|\`|\%|\!|\?|\{|\}|\(|\)|\[|\]|\\|@|:|/g, "").replace(/^-/, "").replace(/-$/, "");
				$item.attr('id', "toc-" + arr);

				$links += "<li><a class='anchor' href='#toc-" + arr + "'>" + iconHtml + "<span class='pai-name'>" + name + "</span> <span class='pai-more'>" + moreInfoLabel +"</span></a></li>";
			});

			$list.prepend($links);
			$(this).prepend($list);
			if($links.length) $(this).removeClass('hidden');
		});
	}
};


// DrugInteractionsModule
$(document).ready(function () {
	$("#interaction-consult__show-more-pharmacies").on("click", function (e) {
		e.preventDefault();
		$(".interaction-consult__pharmacy-hidden").removeClass('interaction-consult__pharmacy-hidden');
		$(this).hide();
	});

	$("#input-more-interactions").on("click", function () {
		$(".interaction-add__item").show();
		$("#input-more-interactions").hide();
	});

});
/**/
